// utils/roleBasedReducers.js

import adminSlices from '../features/admin/adminSlices.js';
import purchaseManagerSlices from '../features/purchase-manager/purchaseManagerSlice.js';
import salesExecutiveSlices from '../features/sales-executive/SalesExecutiveSlices.js';
import warehouseManagerSlices from '../features/warehouse-manager/WareHouseManagerSlice.js';

const roleBasedReducers = {
    admin: adminSlices,
    purchase_manager: purchaseManagerSlices,
    sales_executive: salesExecutiveSlices,
    warehouse_manager: warehouseManagerSlices

};
export default roleBasedReducers;